/**
 * サウナ相談フォームのJavaScript制御
 * GAS（Google Apps Script）連携版 v2.0
 * 
 * v2.0 - EmailJSを完全廃止し、GASでメール送信＋スプレッドシート記録を一本化
 * v1.0 - EmailJS連携版（旧版）
 * 
 * 初心者向けのコメント付きで実装しています。
 * 
 * ★ 変更点まとめ（v1.0 → v2.0）:
 *   - EmailJS関連のコード（initEmailJS, emailjs.send等）を全削除
 *   - GAS Web Appへの送信で「メール送信」と「スプレッドシート記録」を同時に実行
 *   - fetch の mode を 'no-cors' → GASリダイレクト対応に変更し、成功/失敗を判定可能に
 *   - ログ専用の sendLogToGAS() は「エラーログ」送信用として残存
 */

// GAS Web App URL（スプレッドシート連携 + メール送信用）
// ※ このURLは既存のGASデプロイURLと同じです（GAS側をv2.0に更新してください）
const GAS_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxaTJqdAtAVtKbgEJblmxJATP4gSlsV2qd9ZkdtOxAV-yvmXnU6tgMnoKTDN-tEGPEo/exec';

// ============================================================
// パッシブ型ボット対策設定
// 外部サービスに依存せず、通常ユーザーの操作を邪魔しない対策です。
// ============================================================
const SAUNA_BOT_PROTECTION = {
    pageLoadTime: Date.now(),
    userInteracted: false,
    MIN_SUBMIT_TIME_MS: 3000,
    MAX_SPACE_WIDTH_CM: 1000,
    MAX_SPACE_DEPTH_CM: 1000,
    MAX_SPACE_HEIGHT_CM: 500,
    MAX_SPACE_DIGITS: 4,
    BLOCK_SCORE: 5
};

// DOM（ページの要素）が読み込まれた後に実行される関数
document.addEventListener('DOMContentLoaded', function() {
    console.log('サウナフォームが初期化されました（GAS版 v2.0）');
    
    // フォーム要素の取得
    const form = document.getElementById('SaunaConsultationForm');
    if (!form) {
        console.error('フォームが見つかりません');
        return;
    }

    // 連絡方法の制御機能を初期化
    initContactMethodControl();

    // パッシブ型ボット対策を初期化
    initSaunaBotProtection();
    
    // 郵便番号自動補完機能を初期化
    initZipcodeAutoComplete();
    
    // フォームバリデーション機能を初期化
    initFormValidation();
    
    // 数字入力欄の全角半角変換機能を初期化
    initNumberFieldsNormalization();
    
    // 送信ボタンのローディング機能を初期化
    initSubmitButtonLoading();
    
    // GAS送信機能を初期化（旧EmailJS送信の代替）
    initGASSubmission();
    
    // 必須項目の薄黄色ハイライト機能を初期化（contactページと同じ色）
    initRequiredFieldHighlight();

    // ストーブ計算機からの流入時、計算結果を自由記述欄へ自動転記
    prefillFromStoveCalc();
});

/**
 * ストーブ計算機（/pages/stove-calculator）の結果CTAから遷移した場合、
 * URLクエリ（from=stove_calc, power, volume, heater）を読み取り、
 * その内容を「その他ご要望」欄へ自動転記して再入力の手間を省く。
 * 商品ページの「どのモデルが合うか無料相談」（from=product, model）は商品名を転記する。
 * 既に入力がある場合は上書きしない。
 */
function prefillFromStoveCalc() {
    try {
        var params = new URLSearchParams(window.location.search);
        var from = params.get('from');
        if (from !== 'stove_calc' && from !== 'product') return;

        var field = document.getElementById('SaunaConsultationForm-other-requests');
        if (!field || field.value.trim() !== '') return;

        if (from === 'product') {
            var model = (params.get('model') || '').slice(0, 120);
            if (!model) return;
            field.value = '検討中の商品：' + model + '\n';
            updateSingleFieldHighlight(field);
            return;
        }

        var power = params.get('power');
        var volume = params.get('volume');
        var heater = params.get('heater');
        var dims = params.get('dims');

        var lines = ['【サウナストーブ計算機の結果より】'];
        if (dims) lines.push('サウナ室内寸（計算に使用）：' + dims);
        if (volume) lines.push('サウナ室の有効体積：約' + volume + '㎥');
        if (power) lines.push('推奨出力の目安：約' + power + 'kW');
        if (heater) lines.push('ストーブ種別：' + heater);
        lines.push('上記の条件に合う機種とサウナのご提案を希望します。');

        field.value = lines.join('\n');
        updateSingleFieldHighlight(field);
        console.log('ストーブ計算機の結果を自由記述欄へ転記しました');
    } catch (e) {
        console.warn('ストーブ計算機からの自動転記をスキップ:', e);
    }
}

/**
 * GAS送信機能の初期化
 * フォーム送信時にGASへデータを送り、メール送信＋スプレッドシート記録を行う
 */
function initGASSubmission() {
    console.log('GAS送信機能を初期化中...');
    
    const form = document.getElementById('SaunaConsultationForm');
    if (!form) return;
    
    // フォーム送信イベントを上書き
    form.addEventListener('submit', function(e) {
        e.preventDefault(); // 通常のフォーム送信を停止
        
        console.log('GAS経由でフォーム送信を開始...');
        
        // バリデーションチェック
        if (!window.validateForm()) {
            console.log('バリデーションエラーがあるため送信を停止');
            return false;
        }

        // ボット判定チェック
        const botCheck = checkSaunaBotSignals();
        if (botCheck.isBot) {
            console.warn('ボットと判定したため送信を停止します:', botCheck.reasons.join(', '));
            recordBlockedSubmission(botCheck);
            // スパマーに余計な情報を与えないため、成功表示に見せかけて終了
            handleSubmissionSuccess();
            return false;
        }
        
        // 送信処理開始
        handleGASSubmission();
    });
}

/** ボット判定で止めた送信をログにだけ残す（メールは送らない） */
function recordBlockedSubmission(botCheck) {
    var blockedId = 'BLOCKED-' + generateInquiryId();
    var name = document.getElementById('SaunaConsultationForm-name')?.value || '';
    var contactMethod = getRadioValue('contact[ご希望の連絡方法]') || '';
    var requests = document.getElementById('SaunaConsultationForm-other-requests')?.value || '';
    var preview = ['名前:' + name, '連絡先:' + buildContactInfo(contactMethod), '要望:' + requests]
        .join(' / ').slice(0, 300);

    sendLogToGAS(blockedId, 'BLOCKED', botCheck.reasons,
        ['ボット判定で送信停止（score ' + botCheck.score + '）'], {
            contactMethod: contactMethod,
            inquiryType: 'サウナ相談',
            messagePreview: preview
        });

    try {
        if (typeof gtag === 'function') {
            gtag('event', 'form_blocked', {
                transport_type: 'beacon',
                form_name: 'sauna_support_form',
                block_reasons: botCheck.reasons.join(',').slice(0, 100),
                block_score: botCheck.score
            });
        }
    } catch (e) {
        console.warn('GA4 form_blocked 送信失敗:', e);
    }
}

/**
 * パッシブ型ボット対策の初期化
 * キー入力・クリック・タッチなどを1回でも検出したら人間操作の可能性を上げます。
 */
function initSaunaBotProtection() {
    const form = document.getElementById('SaunaConsultationForm');
    if (!form) return;

    ['keydown', 'click', 'touchstart', 'mousemove'].forEach(function(eventName) {
        form.addEventListener(eventName, function() {
            SAUNA_BOT_PROTECTION.userInteracted = true;
        }, { once: true });
    });

    // 設置スペース欄は、巨大な数値が入らないように入力中にも軽く整形
    ['SaunaConsultationForm-width', 'SaunaConsultationForm-depth', 'SaunaConsultationForm-height'].forEach(function(fieldId) {
        const field = document.getElementById(fieldId);
        if (!field) return;

        field.addEventListener('input', function(e) {
            var value = String(e.target.value || '');
            // 指数表記や記号まじりを避けるため、数字のみを残す
            value = value.replace(/[^0-9]/g, '');
            if (value.length > SAUNA_BOT_PROTECTION.MAX_SPACE_DIGITS) {
                value = value.slice(0, SAUNA_BOT_PROTECTION.MAX_SPACE_DIGITS);
            }
            e.target.value = value;
            updateSpaceUnitHint();
        });
    });
}

/** 設置スペースが上限を超えたら単位の案内を出す（送信は止めない） */
function updateSpaceUnitHint() {
    var configs = [
        ['SaunaConsultationForm-width', SAUNA_BOT_PROTECTION.MAX_SPACE_WIDTH_CM],
        ['SaunaConsultationForm-depth', SAUNA_BOT_PROTECTION.MAX_SPACE_DEPTH_CM],
        ['SaunaConsultationForm-height', SAUNA_BOT_PROTECTION.MAX_SPACE_HEIGHT_CM]
    ];
    var over = configs.some(function(c) {
        var el = document.getElementById(c[0]);
        return el && /^\d+$/.test(el.value) && parseInt(el.value, 10) > c[1];
    });

    var group = document.querySelector('#SaunaConsultationForm .space-inputs');
    if (!group) return;
    var hint = document.getElementById('SaunaConsultationForm-space-hint');
    if (!hint) {
        hint = document.createElement('p');
        hint.id = 'SaunaConsultationForm-space-hint';
        hint.setAttribute('role', 'status');
        hint.style.cssText = 'margin:8px 0 0;font-size:0.9em;line-height:1.6;';
        group.parentNode.insertBefore(hint, group.nextSibling);
    }
    hint.textContent = over
        ? '※ cm でご入力ください（例：2m → 200）。mm のまま送信いただいても、担当者が確認します。'
        : '';
}

/**
 * スパムの特徴をスコア方式で判定
 * 1条件だけでは即ブロックせず、複数の怪しい特徴が重なったときに弾きます。
 */
function checkSaunaBotSignals() {
    var score = 0;
    var reasons = [];

    // ハニーポット
    var honeypot = document.getElementById('SaunaConsultationForm-website');
    if (honeypot && honeypot.value.trim() !== '') {
        score += 5;
        reasons.push('HONEYPOT_FILLED');
    }

    // 送信までの時間が短すぎる
    var elapsed = Date.now() - SAUNA_BOT_PROTECTION.pageLoadTime;
    if (elapsed < SAUNA_BOT_PROTECTION.MIN_SUBMIT_TIME_MS) {
        score += 3;
        reasons.push('TOO_FAST_SUBMIT');
    }

    // フォーム操作が見えない
    if (!SAUNA_BOT_PROTECTION.userInteracted) {
        score += 2;
        reasons.push('NO_USER_INTERACTION');
    }

    // 設置スペース: 形式外は強いシグナル、上限超え（mm入力の可能性）は弱いシグナル
    var spaceSignals = validateSpaceRangesForBotCheck();
    if (spaceSignals.botReasons.length > 0) {
        score += 5;
        reasons = reasons.concat(spaceSignals.botReasons);
    }
    if (spaceSignals.rangeReasons.length > 0) {
        score += 3;
        reasons = reasons.concat(spaceSignals.rangeReasons);
    }

    return {
        isBot: score >= SAUNA_BOT_PROTECTION.BLOCK_SCORE,
        score: score,
        reasons: reasons
    };
}

/**
 * 設置スペースの任意入力欄について、明らかに不自然な巨大値だけを検出します。
 * 未入力は正常扱いにします。
 */
function validateSpaceRangesForBotCheck() {
    var botReasons = [];
    var rangeReasons = [];
    var configs = [
        { id: 'SaunaConsultationForm-width', max: SAUNA_BOT_PROTECTION.MAX_SPACE_WIDTH_CM, code: 'SPACE_WIDTH_OUT_OF_RANGE' },
        { id: 'SaunaConsultationForm-depth', max: SAUNA_BOT_PROTECTION.MAX_SPACE_DEPTH_CM, code: 'SPACE_DEPTH_OUT_OF_RANGE' },
        { id: 'SaunaConsultationForm-height', max: SAUNA_BOT_PROTECTION.MAX_SPACE_HEIGHT_CM, code: 'SPACE_HEIGHT_OUT_OF_RANGE' }
    ];

    configs.forEach(function(config) {
        var field = document.getElementById(config.id);
        if (!field) return;

        var raw = String(field.value || '').trim();
        if (!raw) return; // 任意入力なので未入力はOK

        if (!/^\d+$/.test(raw)) {
            botReasons.push(config.code + '_INVALID_FORMAT');
            return;
        }

        if (raw.length > SAUNA_BOT_PROTECTION.MAX_SPACE_DIGITS) {
            botReasons.push(config.code + '_TOO_MANY_DIGITS');
            return;
        }

        var numericValue = parseInt(raw, 10);
        if (numericValue > config.max) {
            rangeReasons.push(config.code);
        }
    });

    return { botReasons: botReasons, rangeReasons: rangeReasons };
}

/** 上限超えの値には注記を付けて送る */
function formatSpaceValueForSubmit(fieldId, max) {
    var raw = String(document.getElementById(fieldId)?.value || '').trim();
    if (!raw) return '未指定';
    if (/^\d{1,4}$/.test(raw) && parseInt(raw, 10) > max) {
        return raw + '（※上限超え：mmで入力された可能性あり）';
    }
    return raw;
}

/**
 * GAS経由でのフォーム送信処理
 * 1つのリクエストで「メール送信」「スプレッドシート全内容記録」「ログ記録」を全て実行
 */
async function handleGASSubmission() {
    console.log('GAS送信処理を開始...');
    
    // ログ用のinquiry_idを生成
    const inquiryId = generateInquiryId();
    console.log('inquiry_id:', inquiryId);
    
    try {
        // ローディング状態開始（ボタンを「送信中...」に変更）
        setSubmitButtonLoading(true);
        
        // フォームデータを収集してGAS送信用に変換
        const submitData = buildGASSubmitData(inquiryId);
        
        console.log('送信データ:', submitData);
        
        // ========================================
        // GASへデータを送信
        // ========================================
        // GAS Web Appは POST → リダイレクト(302) → JSONレスポンス という流れになる
        // fetch の redirect: 'follow' でリダイレクト先のレスポンスを取得する
        const response = await fetch(GAS_WEB_APP_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain;charset=utf-8'
            },
            body: JSON.stringify(submitData),
            redirect: 'follow'  // GASのリダイレクトに追従する
        });
        
        // レスポンスの解析
        // GAS Web Appは302リダイレクト後にJSONを返す
        // redirect: 'follow' の場合、最終的なレスポンスが取得できる
        let result;
        try {
            result = await response.json();
        } catch (parseError) {
            // JSONパースに失敗した場合（GASのリダイレクトでOpaqueレスポンスになる場合がある）
            // レスポンスが返ってきている時点でGAS側は処理完了とみなす
            console.log('レスポンスのJSONパースに失敗（GASリダイレクトによるもの）。処理完了とみなします。');
            result = { status: 'ok' };
        }
        
        console.log('GASレスポンス:', result);
        
        // GASからのレスポンスで成功/失敗を判定
        if (result.status === 'ok') {
            console.log('GAS送信成功！');
            
            // メタ広告（Meta Ads）用コンバージョン計測
            // ★成功直後に一度だけLead発火（リロード二重対策つき）
            try {
                if (window.fbq && !sessionStorage.getItem('lead_fired')) {
                    fbq('track', 'Lead');
                    sessionStorage.setItem('lead_fired', '1');
                }
            } catch (e) {
                console.warn('Lead tracking skipped:', e);
            }
            
            // 送信成功時の処理（サンクスページへ遷移）
            handleSubmissionSuccess(inquiryId);
        } else {
            // GASがエラーレスポンスを返した場合
            throw new Error(result.message || 'GASサーバーエラー');
        }
        
    } catch (error) {
        console.error('GAS送信エラー:', error);
        
        // GASにエラーログを送信（ログ専用の従来関数を使用）
        sendLogToGAS(inquiryId, 'ERROR', ['ERR_GAS_SEND'], 
            ['GAS送信エラー: ' + (error.message || String(error))], {
                contactMethod: getRadioValue('contact[ご希望の連絡方法]') || '',
                inquiryType: 'サウナ相談',
                messagePreview: ''
            });
        
        handleSubmissionError(error);
    } finally {
        // ローディング状態解除
        setSubmitButtonLoading(false);
    }
}

/**
 * GAS送信用のデータを構築
 * フォームの全入力内容 + デバイス情報 + action識別子をまとめたJSONを作成
 * 
 * @param {string} inquiryId - 問い合わせID
 * @returns {Object} GASに送信するデータオブジェクト
 */
function buildGASSubmitData(inquiryId) {
    console.log('GAS送信データを構築中...');
    
    // 連絡方法を取得
    const contactMethod = getRadioValue('contact[ご希望の連絡方法]') || '未選択';
    
    // デバイス情報を取得
    const device = getDeviceInfo();
    
    // GAS側で処理を振り分けるための action キー
    // 'sauna_submit' → サウナ相談フォーム用の処理（メール送信＋全内容記録＋ログ）
    const data = {
        action: 'sauna_submit',  // ★ GAS側でサウナ相談処理に振り分けるためのキー
        
        // 問い合わせID・タイムスタンプ
        inquiry_id: inquiryId,
        timestamp: new Date().toISOString(),
        
        // サウナの基本情報
        sauna_type: getRadioValue('contact[サウナのタイプ]') || '未選択',
        sauna_usage: getRadioValue('contact[サウナの用途]') || '未選択',
        user_count: getRadioValue('contact[ご利用人数]') || '未選択',
        location: getRadioValue('contact[設置場所]') || '未選択',
        
        // 設置スペース
        space_width: formatSpaceValueForSubmit('SaunaConsultationForm-width', SAUNA_BOT_PROTECTION.MAX_SPACE_WIDTH_CM),
        space_depth: formatSpaceValueForSubmit('SaunaConsultationForm-depth', SAUNA_BOT_PROTECTION.MAX_SPACE_DEPTH_CM),
        space_height: formatSpaceValueForSubmit('SaunaConsultationForm-height', SAUNA_BOT_PROTECTION.MAX_SPACE_HEIGHT_CM),
        
        // 条件
        budget: getRadioValue('contact[ご予算]') || '未選択',
        delivery_time: getRadioValue('contact[ご希望の納期]') || '未選択',
        
        // 重視したいポイント（複数選択対応）
        important_points: getCheckboxValues('contact[重視したいポイント]').join(', ') || '未選択',
        
        // その他ご要望
        other_requests: document.getElementById('SaunaConsultationForm-other-requests')?.value || 'なし',
        
        // お客様情報
        name: document.getElementById('SaunaConsultationForm-name')?.value || '',
        contact_method: contactMethod,
        
        // 連絡先情報（連絡方法に応じて動的に生成）
        contact_info: buildContactInfo(contactMethod),
        
        // Reply-To用のお客様メールアドレス
        customer_email: document.getElementById('SaunaConsultationForm-email')?.value || 'noreply@idetox.jp',
        
        // デバイス情報（ログ用）
        device_type: device.type,
        screen_width: device.screenWidth,
        browser: device.browser,
        os: device.os
    };
    
    return data;
}

/**
 * 連絡方法に応じた連絡先情報を動的に生成
 */
function buildContactInfo(contactMethod) {
    console.log('連絡先情報を構築中...', contactMethod);
    
    let contactInfo = '';
    
    switch(contactMethod) {
        case '電話':
            const phone = document.getElementById('SaunaConsultationForm-phone')?.value;
            contactInfo = phone ? `電話番号：${phone}` : '';
            break;
            
        case 'メール':
            const email = document.getElementById('SaunaConsultationForm-email')?.value;
            contactInfo = email ? `メールアドレス：${email}` : '';
            break;
            
        case '資料送付':
            const zipcode = document.getElementById('SaunaConsultationForm-zipcode')?.value;
            const prefecture = document.getElementById('SaunaConsultationForm-prefecture')?.value;
            const city = document.getElementById('SaunaConsultationForm-city')?.value;
            const address = document.getElementById('SaunaConsultationForm-address')?.value;
            const deliveryPhone = document.getElementById('SaunaConsultationForm-delivery-phone')?.value;
            
            const addressParts = [];
            if (zipcode) addressParts.push(`郵便番号：${zipcode}`);
            if (prefecture && city && address) {
                addressParts.push(`住所：${prefecture}${city}${address}`);
            }
            if (deliveryPhone) addressParts.push(`電話番号：${deliveryPhone}`);
            
            contactInfo = addressParts.join('\n');
            break;
            
        case 'FAX':
            const fax = document.getElementById('SaunaConsultationForm-fax')?.value;
            contactInfo = fax ? `FAX番号：${fax}` : '';
            break;
            
        default:
            contactInfo = '連絡先情報が設定されていません';
    }
    
    console.log('生成された連絡先情報:', contactInfo);
    return contactInfo;
}

/**
 * ラジオボタンの選択値を取得
 */
function getRadioValue(name) {
    const radio = document.querySelector(`input[name="${name}"]:checked`);
    return radio ? radio.value : null;
}

/**
 * チェックボックスの選択値を配列で取得
 */
function getCheckboxValues(name) {
    const checkboxes = document.querySelectorAll(`input[name="${name}"]:checked`);
    return Array.from(checkboxes).map(cb => cb.value);
}

/**
 * 送信成功時の処理
 * @param {string} [inquiryId] - 問い合わせID（正常送信時のみ渡される。ボット誤検知フェイク成功時は未指定）
 */
function handleSubmissionSuccess(inquiryId) {
    console.log('フォーム送信が成功しました - サンクスページにリダイレクトします');

    // GA4 form_submit イベント発火（inquiry_id 付き）
    // transport_type: 'beacon' でページ遷移中でも確実に配信
    if (inquiryId) {
        if (window.idetoxAdsUserData) {
            window.idetoxAdsUserData({
                email: document.getElementById('SaunaConsultationForm-email')?.value,
                phone: document.getElementById('SaunaConsultationForm-phone')?.value
            });
        }
        try {
            if (typeof gtag === 'function') {
                gtag('event', 'form_submit', {
                    transport_type: 'beacon',
                    event_category: 'contact',
                    event_label: 'sauna_support_form',
                    form_name: 'sauna_support_form',
                    form_destination: 'https://idetox.jp/pages/sauna-support_inquiry_thanks',
                    form_id: 'SaunaSupportForm',
                    inquiry_type: 'サウナ相談',
                    inquiry_id: inquiryId
                });
            }
        } catch (e) {
            console.warn('GA4 form_submit 送信失敗:', e);
        }
    }

    // アラートなしで直接サンクスページにリダイレクト
    if (inquiryId) {
        try {
            if (window.idetoxTrackYahooConversion) {
                window.idetoxTrackYahooConversion({ key: 'sauna-support-' + inquiryId });
            }
        } catch (e) {
            console.warn('Yahoo Ads conversion send failed:', e);
        }

        // OpenAI広告（ChatGPT広告）コンバージョン計測 lead_created（本物の送信成功時のみ）
        try {
            if (window.oaiq) {
                window.oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'idetox_contact_lead' });
            }
        } catch (e) {
            console.warn('OpenAI Ads conversion send failed:', e);
        }
    }

    setTimeout(function() {
        window.location.href = 'https://idetox.jp/pages/sauna-support_inquiry_thanks';
    }, inquiryId ? 500 : 300);
}

/**
 * 送信エラー時の処理
 */
function handleSubmissionError(error) {
    console.error('送信エラーが発生しました:', error);
    
    let errorMessage = 'お問い合わせの送信中にエラーが発生しました。\n';
    
    if (error.message) {
        errorMessage += `詳細: ${error.message}\n`;
    }
    
    errorMessage += 'しばらく時間をおいて再度お試しください。\n';
    errorMessage += '解決しない場合は info@idetox.jp まで直接ご連絡ください。';
    
    alert(errorMessage);
}

/**
 * 送信ボタンのローディング状態制御
 */
function setSubmitButtonLoading(isLoading) {
    const submitButton = document.getElementById('sauna-form-submit');
    if (!submitButton) return;
    
    if (isLoading) {
        submitButton.disabled = true;
        submitButton.value = '送信中...';
        submitButton.style.opacity = '0.7';
        submitButton.style.cursor = 'not-allowed';
        submitButton.style.backgroundColor = '#bdc3c7';
        console.log('送信ボタンを「送信中...」に変更しました');
    } else {
        submitButton.disabled = false;
        submitButton.value = '送信';
        submitButton.style.opacity = '1';
        submitButton.style.cursor = 'pointer';
        submitButton.style.backgroundColor = '#2c3e50';
        console.log('送信ボタンを元の状態に戻しました');
    }
}

/**
 * 数字入力欄の全角半角変換機能
 * 電話番号、FAX番号などの数字入力欄で全角文字を自動的に半角に変換します
 */
function initNumberFieldsNormalization() {
    console.log('数字入力欄の全角半角変換機能を初期化中...');
    
    // 電話番号、FAX番号の入力欄を取得（設置スペースは除外）
    const telFields = document.querySelectorAll('input[type="tel"]');
    
    telFields.forEach(function(field) {
        field.addEventListener('input', function(e) {
            let value = e.target.value;
            
            // 全角数字を半角に変換
            value = value.replace(/[０-９]/g, function(s) {
                return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
            });
            
            // 電話番号とFAX番号の場合は、全角記号も半角に変換
            // 全角ハイフンを半角に変換
            value = value.replace(/[－ー−]/g, '-');
            // 全角括弧を半角に変換
            value = value.replace(/（/g, '(').replace(/）/g, ')');
            // 全角プラスを半角に変換
            value = value.replace(/＋/g, '+');
            
            e.target.value = value;
        });
    });
}

/**
 * 連絡方法選択による動的フィールド表示制御
 * ユーザーが選択した連絡方法に応じて、必要な入力欄だけを表示します
 */
function initContactMethodControl() {
    console.log('連絡方法制御を初期化中...');
    
    // 連絡方法のラジオボタンを全て取得
    const contactMethodRadios = document.querySelectorAll('input[name="contact[ご希望の連絡方法]"]');
    
    // 各入力欄の要素を取得
    const phoneField = document.getElementById('phone-field');
    const emailField = document.getElementById('email-field');
    const addressFields = document.getElementById('address-fields');
    const faxField = document.getElementById('fax-field');
    
    // 要素が見つからない場合はエラーを表示
    if (!phoneField || !emailField || !addressFields || !faxField) {
        console.error('連絡方法フィールドが見つかりません');
        return;
    }
    
    /**
     * 連絡方法が変更された時の処理
     * 選択された方法に応じて適切な入力欄を表示し、必須属性を設定します
     */
    function updateContactFields() {
        // どの連絡方法が選択されているかを取得
        const selectedMethod = document.querySelector('input[name="contact[ご希望の連絡方法]"]:checked');
        
        if (!selectedMethod) {
            console.log('連絡方法が選択されていません');
            return;
        }
        
        const methodValue = selectedMethod.getAttribute('data-contact-method');
        console.log('選択された連絡方法:', methodValue);
        
        // まず全ての入力欄を非表示にして、必須属性も解除
        hideAllContactFields();
        
        // 選択された連絡方法に応じて適切な入力欄を表示
        switch(methodValue) {
            case 'phone':
                // 電話が選択された場合
                showField(phoneField);
                setFieldRequired('SaunaConsultationForm-phone', true, '電話番号');
                console.log('電話フィールドを表示しました');
                break;
                
            case 'email':
                // メールが選択された場合
                showField(emailField);
                setFieldRequired('SaunaConsultationForm-email', true, 'メールアドレス');
                console.log('メールフィールドを表示しました');
                break;
                
            case 'mail':
                // 資料送付が選択された場合
                showField(addressFields);
                // 住所関連の全ての項目を必須に設定
                setFieldRequired('SaunaConsultationForm-zipcode', true, '郵便番号');
                setFieldRequired('SaunaConsultationForm-prefecture', true, '都道府県');
                setFieldRequired('SaunaConsultationForm-city', true, '市町村');
                setFieldRequired('SaunaConsultationForm-address', true, '番地・マンション名等');
                setFieldRequired('SaunaConsultationForm-delivery-phone', true, '送付先電話番号');
                console.log('住所フィールドを表示しました');
                break;
                
            case 'fax':
                // FAXが選択された場合
                showField(faxField);
                setFieldRequired('SaunaConsultationForm-fax', true, 'FAX番号');
                console.log('FAXフィールドを表示しました');
                break;
                
            default:
                console.log('不明な連絡方法:', methodValue);
        }
    }
    
    /**
     * 全ての連絡方法フィールドを非表示にする
     */
    function hideAllContactFields() {
        hideField(phoneField);
        hideField(emailField); 
        hideField(addressFields);
        hideField(faxField);
        
        // 全ての必須属性を解除
        setFieldRequired('SaunaConsultationForm-phone', false);
        setFieldRequired('SaunaConsultationForm-email', false);
        setFieldRequired('SaunaConsultationForm-zipcode', false);
        setFieldRequired('SaunaConsultationForm-prefecture', false);
        setFieldRequired('SaunaConsultationForm-city', false);
        setFieldRequired('SaunaConsultationForm-address', false);
        setFieldRequired('SaunaConsultationForm-delivery-phone', false);
        setFieldRequired('SaunaConsultationForm-fax', false);
    }
    
    /**
     * フィールドを表示する
     */
    function showField(field) {
        if (field) {
            field.style.display = 'block';
            field.style.opacity = '1';
        }
    }
    
    /**
     * フィールドを非表示にする
     */
    function hideField(field) {
        if (field) {
            field.style.display = 'none';
            field.style.opacity = '0';
        }
    }
    
    /**
     * フィールドの必須属性を設定/解除する
     */
    function setFieldRequired(fieldId, isRequired, fieldName = '') {
        const field = document.getElementById(fieldId);
        if (!field) return;
        
        if (isRequired) {
            field.setAttribute('required', 'required');
            field.setAttribute('data-form_required', fieldName);
            field.setAttribute('aria-required', 'true');
        } else {
            field.removeAttribute('required');
            field.removeAttribute('data-form_required');
            field.removeAttribute('aria-required');
            // エラー状態もクリア
            field.classList.remove('error', 'required-field-highlight');
        }
    }
    
    // 各ラジオボタンに変更イベントを追加
    contactMethodRadios.forEach(function(radio) {
        radio.addEventListener('change', updateContactFields);
    });
    
    // 初期状態の設定（ページ読み込み時）
    updateContactFields();
}

/**
 * 郵便番号自動補完機能
 * zipcloud APIを使用して郵便番号から住所を自動入力します
 */
function initZipcodeAutoComplete() {
    console.log('郵便番号自動補完機能を初期化中...');
    
    const zipcodeField = document.getElementById('SaunaConsultationForm-zipcode');
    const prefectureField = document.getElementById('SaunaConsultationForm-prefecture');
    const cityField = document.getElementById('SaunaConsultationForm-city');
    const searchButton = document.getElementById('zipcode-search-button');
    
    if (!zipcodeField || !prefectureField || !cityField || !searchButton) {
        console.error('郵便番号関連フィールドが見つかりません');
        return;
    }
    
    /**
     * 郵便番号から住所を検索する
     */
    function searchAddress() {
        const zipcode = zipcodeField.value.trim();
        
        // 郵便番号の形式チェック（ハイフンを除去）
        const cleanZipcode = zipcode.replace(/[^0-9]/g, '');
        
        if (cleanZipcode.length !== 7) {
            alert('郵便番号は半角数字7桁で入力してください。\n（例：1234567）');
            zipcodeField.focus();
            return;
        }
        
        console.log('住所を検索中...', cleanZipcode);
        
        // ローディング状態を表示
        searchButton.disabled = true;
        searchButton.textContent = '検索中...';
        
        // zipcloud APIに問い合わせ
        const apiUrl = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${cleanZipcode}`;
        
        fetch(apiUrl)
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('通信エラー: ' + response.status);
                }
                return response.json();
            })
            .then(function(data) {
                console.log('API応答:', data);
                
                if (data.status === 200 && data.results && data.results.length > 0) {
                    // 住所情報を取得（最初の結果を使用）
                    const result = data.results[0];
                    
                    // 都道府県を設定
                    prefectureField.value = result.address1;
                    
                    // 市町村を設定（address2 + address3を結合）
                    const city = result.address2 + result.address3;
                    cityField.value = city;
                    
                    console.log('住所を自動入力しました:', result.address1, city);
                    
                    // 成功を示すエフェクト
                    prefectureField.style.backgroundColor = '#d4edda';
                    cityField.style.backgroundColor = '#d4edda';
                    
                    setTimeout(function() {
                        prefectureField.style.backgroundColor = '';
                        cityField.style.backgroundColor = '';
                    }, 2000);
                    
                } else {
                    console.log('住所が見つかりませんでした');
                    alert('入力された郵便番号の住所が見つかりませんでした。\n郵便番号を確認してください。');
                    zipcodeField.focus();
                }
            })
            .catch(function(error) {
                console.error('住所検索エラー:', error);
                alert('住所の検索中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。');
            })
            .finally(function() {
                // ローディング状態を解除
                searchButton.disabled = false;
                searchButton.textContent = '住所自動入力';
            });
    }
    
    // 郵便番号入力時のイベント処理（数字のみ、7桁まで制限）
    zipcodeField.addEventListener('input', function(e) {
        let value = e.target.value;
        
        // 全角数字を半角に変換
        value = value.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        
        // 数字以外を除去
        value = value.replace(/[^0-9]/g, '');
        
        // 7桁まで制限
        if (value.length > 7) {
            value = value.slice(0, 7);
        }
        
        e.target.value = value;
    });
    
    // 住所自動入力ボタンのクリックイベント
    searchButton.addEventListener('click', function(e) {
        e.preventDefault(); // フォーム送信を防ぐ
        searchAddress();
    });
    
    // Enterキーでも検索実行
    zipcodeField.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault(); // フォーム送信を防ぐ
            searchAddress();
        }
    });
}

/**
 * フォームバリデーション機能
 * 必須項目のチェックやエラー表示を行います
 * ※ submitイベントハンドラーはinitGASSubmission()に一本化済み
 *   （二重ハンドラー防止のため、ここでは登録しない）
 */
function initFormValidation() {
    console.log('フォームバリデーション機能を初期化中...');
    
    const form = document.getElementById('SaunaConsultationForm');
    const submitButton = form.querySelector('input[type="submit"]');
    
    // ★ submitイベントハンドラーはinitGASSubmission()に統合済みのため、
    //    ここでは登録しない（二重ハンドラー防止）
    
    /**
     * フォーム全体のバリデーション
     */
    function validateForm() {
        let isValid = true;
        const errors = [];
        
        // 必須項目をチェック
        const requiredFields = form.querySelectorAll('[data-form_required]');
        
        requiredFields.forEach(function(field) {
            const fieldName = field.getAttribute('data-form_required');
            const value = field.value.trim();
            
            if (!value) {
                // 必須項目が未入力の場合
                markFieldAsError(field, fieldName + 'は必須項目です');
                errors.push(fieldName);
                isValid = false;
            } else {
                // 入力されている場合はエラー状態を解除
                clearFieldError(field);
                
                // 特定フィールドの詳細バリデーション
                if (!validateSpecificField(field, fieldName)) {
                    isValid = false;
                    // 計測: 形式エラーで止まった項目も記録（未入力だけでなく）
                    try {
                        if (typeof window.gtag === 'function') {
                            window.gtag('event', 'form_validation_fail', { form_id: 'sauna', field_name: fieldName, reason: 'format' });
                        }
                    } catch (e) {}
                }
            }
        });
        
        // お名前は常に必須
        const nameField = document.getElementById('SaunaConsultationForm-name');
        if (nameField && !nameField.value.trim()) {
            markFieldAsError(nameField, 'お名前は必須項目です');
            errors.push('お名前');
            isValid = false;
        }
        
        // 連絡方法の選択チェック
        const contactMethod = document.querySelector('input[name="contact[ご希望の連絡方法]"]:checked');
        if (!contactMethod) {
            errors.push('ご希望の連絡方法');
            isValid = false;
        }
        
        // エラーがある場合は最初のエラーフィールドにフォーカス
        if (!isValid) {
            const firstErrorField = form.querySelector('.error, .required-field-highlight');
            if (firstErrorField) {
                firstErrorField.focus();
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            // 計測: どの項目で検証が止まったか（項目別離脱の把握・観測用）
            try {
                if (typeof window.gtag === 'function') {
                    errors.forEach(function (fieldName) {
                        window.gtag('event', 'form_validation_fail', { form_id: 'sauna', field_name: fieldName, reason: 'required' });
                    });
                }
            } catch (e) {}

            alert('必須項目に未入力があります。\n' + errors.join('、') + '\nを入力してください。');
        }

        return isValid;
    }
    
    // バリデーション関数をグローバルスコープで利用可能にする
    window.validateForm = validateForm;
    
    /**
     * 特定フィールドの詳細バリデーション
     */
    function validateSpecificField(field, fieldName) {
        const value = field.value.trim();
        
        // メールアドレスの形式チェック
        if (field.type === 'email') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(value)) {
                markFieldAsError(field, 'メールアドレスの形式が正しくありません');
                return false;
            }
        }
        
        // 電話番号の形式チェック
        if (field.type === 'tel') {
            const phonePattern = /^[0-9\-\+\(\)\s]+$/;
            if (!phonePattern.test(value)) {
                markFieldAsError(field, '電話番号は半角数字とハイフンで入力してください（例：03-1234-5678）');
                return false;
            }
        }
        
        // 郵便番号の形式チェック（ハイフン無しの7桁）
        if (field.id.includes('zipcode')) {
            const zipcodePattern = /^[0-9]{7}$/;
            if (!zipcodePattern.test(value)) {
                markFieldAsError(field, '郵便番号は半角数字7桁で入力してください（例：1234567）');
                return false;
            }
        }

        // 設置スペースの上限チェック（任意入力なので、入力がある場合のみ確認）
        if (field.id === 'SaunaConsultationForm-width' && value) {
            if (!/^\d{1,4}$/.test(value) || parseInt(value, 10) > SAUNA_BOT_PROTECTION.MAX_SPACE_WIDTH_CM) {
                markFieldAsError(field, '幅は半角数字で1000cm以下を入力してください');
                return false;
            }
        }

        if (field.id === 'SaunaConsultationForm-depth' && value) {
            if (!/^\d{1,4}$/.test(value) || parseInt(value, 10) > SAUNA_BOT_PROTECTION.MAX_SPACE_DEPTH_CM) {
                markFieldAsError(field, '奥行は半角数字で1000cm以下を入力してください');
                return false;
            }
        }

        if (field.id === 'SaunaConsultationForm-height' && value) {
            if (!/^\d{1,4}$/.test(value) || parseInt(value, 10) > SAUNA_BOT_PROTECTION.MAX_SPACE_HEIGHT_CM) {
                markFieldAsError(field, '高さは半角数字で500cm以下を入力してください');
                return false;
            }
        }
        
        return true;
    }
    
    /**
     * フィールドをエラー状態にする
     */
    function markFieldAsError(field, message) {
        field.classList.add('error', 'required-field-highlight');
        
        // 既存のエラーメッセージを削除
        const existingError = field.parentNode.querySelector('.field-error');
        if (existingError) {
            existingError.remove();
        }
        
        // 新しいエラーメッセージを追加
        const errorElement = document.createElement('span');
        errorElement.className = 'field-error';
        errorElement.textContent = message;
        field.parentNode.appendChild(errorElement);
    }
    
    /**
     * フィールドのエラー状態を解除する
     */
    function clearFieldError(field) {
        field.classList.remove('error', 'required-field-highlight');
        
        const errorElement = field.parentNode.querySelector('.field-error');
        if (errorElement) {
            errorElement.remove();
        }
    }
    
    // リアルタイムバリデーション（入力中のチェック）
    const allInputs = form.querySelectorAll('input, select, textarea');
    allInputs.forEach(function(input) {
        input.addEventListener('blur', function() {
            if (this.hasAttribute('data-form_required') || this.hasAttribute('required')) {
                const fieldName = this.getAttribute('data-form_required') || 'この項目';
                
                if (!this.value.trim()) {
                    markFieldAsError(this, fieldName + 'は必須項目です');
                } else {
                    clearFieldError(this);
                    validateSpecificField(this, fieldName);
                }
            }
        });
        
        // 入力中はエラー状態を解除
        input.addEventListener('input', function() {
            if (this.classList.contains('error')) {
                clearFieldError(this);
            }
        });
    });
}

/**
 * デバッグ用：フォームデータの確認
 */
function debugFormData() {
    const form = document.getElementById('SaunaConsultationForm');
    const formData = new FormData(form);
    
    console.log('=== フォームデータ ===');
    for (let [key, value] of formData.entries()) {
        console.log(key + ':', value);
    }
    console.log('====================');
}

/**
 * 送信ボタンのローディング機能を初期化
 * ※ ローディング制御は handleGASSubmission() 内の setSubmitButtonLoading() に一本化
 */
function initSubmitButtonLoading() {
    console.log('送信ボタンのローディング機能を初期化中...');
    
    const form = document.getElementById('SaunaConsultationForm');
    const submitButton = document.getElementById('sauna-form-submit');
    
    if (!form || !submitButton) {
        console.error('フォームまたは送信ボタンが見つかりません');
        return;
    }
    
    // エラー時のリセット用（外部から呼び出せるように公開）
    window.resetSubmitButton = function() {
        console.log('送信ボタンのローディング状態を解除します');
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
        submitButton.value = '送信';
        submitButton.style.cursor = 'pointer';
        submitButton.style.opacity = '1';
    };
}

// ============================================================
// GAS スプレッドシート連携（エラーログ送信用 - 従来互換）
// ============================================================

/**
 * 一意の inquiry_id を生成
 * フォーマット: SAUNA-YYYYMMDD-xxxxx（contactページの INQ- と区別）
 */
function generateInquiryId() {
    var now = new Date();
    var dateStr = now.getFullYear().toString() +
                  ('0' + (now.getMonth() + 1)).slice(-2) +
                  ('0' + now.getDate()).slice(-2);
    var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var randomStr = '';
    for (var i = 0; i < 5; i++) {
        randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return 'SAUNA-' + dateStr + '-' + randomStr;
}

/**
 * デバイス情報を取得（ログ記録用）
 */
function getDeviceInfo() {
    var ua = navigator.userAgent;
    var deviceType = 'desktop';
    if (/iPhone|iPod/.test(ua)) deviceType = 'mobile_ios';
    else if (/Android.*Mobile/.test(ua)) deviceType = 'mobile_android';
    else if (/iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) deviceType = 'tablet_ios';
    else if (/Android/.test(ua)) deviceType = 'tablet_android';

    var browser = 'unknown';
    if (/CriOS/.test(ua)) browser = 'Chrome iOS';
    else if (/FxiOS/.test(ua)) browser = 'Firefox iOS';
    else if (/EdgiOS/.test(ua) || /Edg\//.test(ua)) browser = 'Edge';
    else if (/Chrome\//.test(ua) && !/Edge/.test(ua)) browser = 'Chrome';
    else if (/Safari\//.test(ua) && !/Chrome/.test(ua)) browser = 'Safari';
    else if (/Firefox\//.test(ua)) browser = 'Firefox';

    var os = 'unknown';
    if (/Windows NT 10/.test(ua)) os = 'Windows 10/11';
    else if (/Windows/.test(ua)) os = 'Windows';
    else if (/Mac OS X/.test(ua)) os = 'macOS';
    else if (/iPhone|iPad|iPod/.test(ua)) os = 'iOS';
    else if (/Android/.test(ua)) os = 'Android';
    else if (/Linux/.test(ua)) os = 'Linux';

    return { type: deviceType, screenWidth: window.innerWidth, browser: browser, os: os };
}

/**
 * GAS Web App にエラーログを送信（従来互換）
 * ※ 成功時のログはhandleGASSubmission内でGASが自動記録するため、
 *   この関数はエラー発生時のログ送信用として残しています。
 * 
 * @param {string} inquiryId - 問い合わせID（SAUNA-xxxx形式）
 * @param {string} status - 'SUCCESS' or 'ERROR'
 * @param {Array} errorCodes - エラーコードの配列
 * @param {Array} errorDetails - エラー詳細の配列
 * @param {Object} extraData - 追加データ（連絡方法、問い合わせ種類等）
 */
function sendLogToGAS(inquiryId, status, errorCodes, errorDetails, extraData) {
    if (!GAS_WEB_APP_URL) {
        console.log('GAS Web App URLが未設定のため、ログ送信をスキップ');
        return;
    }

    var device = getDeviceInfo();
    var payload = {
        // action未指定 → GAS側で従来のログ記録のみ実行（handleLogOnly）
        inquiry_id: inquiryId,
        timestamp: new Date().toISOString(),
        status: status,
        error_codes: (errorCodes || []).join(','),
        error_details: (errorDetails || []).join(' | '),
        device_type: device.type,
        screen_width: device.screenWidth,
        browser: device.browser,
        os: device.os,
        contact_method: (extraData && extraData.contactMethod) || '',
        inquiry_type: (extraData && extraData.inquiryType) || 'サウナ相談',
        message_preview: (extraData && extraData.messagePreview) || ''
    };

    console.log('GASへエラーログ送信:', payload);

    try {
        fetch(GAS_WEB_APP_URL, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            body: JSON.stringify(payload)
        }).then(function() {
            console.log('GASエラーログ送信完了');
        }).catch(function(err) {
            console.warn('GASエラーログ送信エラー（フォーム送信には影響なし）:', err);
        });
    } catch (e) {
        console.warn('GASエラーログ送信例外（フォーム送信には影響なし）:', e);
    }
}

// ============================================================
// 必須項目ハイライト機能（contactページと同じ薄黄色 #fff9c4）
// ============================================================

/**
 * 必須項目の薄黄色ハイライト機能を初期化
 * 初期表示で未入力の必須フィールドに薄黄色を適用し、
 * 入力が完了したらハイライトを解除します。
 */
function initRequiredFieldHighlight() {
    console.log('必須項目ハイライト機能を初期化中...');
    
    // 初期状態のハイライト適用（少し遅延してDOMの準備を待つ）
    setTimeout(function() {
        updateRequiredHighlights();
    }, 500);
    
    // 連絡方法変更時にハイライトを再計算
    var contactMethodRadios = document.querySelectorAll('input[name="contact[ご希望の連絡方法]"]');
    contactMethodRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
            setTimeout(updateRequiredHighlights, 100);
        });
    });
    
    // 全入力フィールドのinput/blurイベントでハイライト更新
    var form = document.getElementById('SaunaConsultationForm');
    if (!form) return;
    
    var allInputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], textarea, select');
    allInputs.forEach(function(input) {
        input.addEventListener('input', function() {
            updateSingleFieldHighlight(this);
        });
        input.addEventListener('blur', function() {
            updateSingleFieldHighlight(this);
        });
    });
}

/**
 * 全必須フィールドのハイライト状態を更新
 */
function updateRequiredHighlights() {
    var form = document.getElementById('SaunaConsultationForm');
    if (!form) return;
    
    // お名前（常に必須）
    var nameField = document.getElementById('SaunaConsultationForm-name');
    if (nameField) updateSingleFieldHighlight(nameField, true);
    
    // 連絡方法に応じた必須フィールドのハイライト
    var selectedMethod = document.querySelector('input[name="contact[ご希望の連絡方法]"]:checked');
    var methodValue = selectedMethod ? selectedMethod.getAttribute('data-contact-method') : '';
    
    // 電話番号
    var phoneField = document.getElementById('SaunaConsultationForm-phone');
    if (phoneField) updateSingleFieldHighlight(phoneField, methodValue === 'phone');
    
    // メールアドレス
    var emailField = document.getElementById('SaunaConsultationForm-email');
    if (emailField) updateSingleFieldHighlight(emailField, methodValue === 'email');
    
    // 資料送付の住所関連フィールド
    var addressFieldIds = ['SaunaConsultationForm-zipcode', 'SaunaConsultationForm-prefecture', 
                           'SaunaConsultationForm-city', 'SaunaConsultationForm-address', 
                           'SaunaConsultationForm-delivery-phone'];
    addressFieldIds.forEach(function(id) {
        var field = document.getElementById(id);
        if (field) updateSingleFieldHighlight(field, methodValue === 'mail');
    });
    
    // FAX番号
    var faxField = document.getElementById('SaunaConsultationForm-fax');
    if (faxField) updateSingleFieldHighlight(faxField, methodValue === 'fax');
}

/**
 * 個別フィールドのハイライト状態を更新
 * @param {Element} field - 入力フィールド要素
 * @param {boolean|undefined} forceRequired - 必須かどうかを明示的に指定（省略時はdata-form_required属性で判定）
 */
function updateSingleFieldHighlight(field, forceRequired) {
    if (!field) return;
    
    // 必須かどうかを判定
    var isRequired = (forceRequired !== undefined) ? forceRequired : 
                     field.hasAttribute('data-form_required') || field.hasAttribute('required');
    var hasValue = field.value && field.value.trim() !== '';
    
    if (isRequired && !hasValue) {
        // 必須で未入力 → 薄黄色ハイライト
        field.classList.add('required-empty');
        field.classList.remove('input-filled');
    } else if (hasValue) {
        // 入力済み → ハイライト解除
        field.classList.remove('required-empty');
        field.classList.add('input-filled');
    } else {
        // 任意で未入力 → ハイライトなし
        field.classList.remove('required-empty');
        field.classList.remove('input-filled');
    }
}

// グローバル関数として公開（デバッグ用）
window.debugFormData = debugFormData;

console.log('サウナフォームのJavaScript初期化が完了しました（GAS版 v2.0）');
